import { render } from "./DateRangePopover.vue?vue&type=template&id=2cff486e&scoped=true&ts=true"
import script from "./DateRangePopover.vue?vue&type=script&lang=ts"
export * from "./DateRangePopover.vue?vue&type=script&lang=ts"

import "./DateRangePopover.vue?vue&type=style&index=0&id=2cff486e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cff486e"]])

export default __exports__